import {TargetContainerFormatterInterface} from "./target_container_formatter/TargetContainerFormatterInterface";
import {InterfaceViewTemplate} from "./InterfaceViewTemplate";
import {InterfacePlatformDocument} from "../../library/infrastracture/platform_document/InterfacePlatformDocument";
import {NullPlatformDocument} from "../../library/infrastracture/platform_document/NullPlatformDocument";
import {NullTargetContainerFormatter} from "./target_container_formatter/NullTargetContainerFormatter";
import {InterfaceApi} from "../../library/infrastracture/api/InterfaceApi";
import {NullApi} from "../../library/infrastracture/api/NullApi";

/**
 * ビューのテンプレートクラス
 */
export abstract class AbstractViewTemplate implements InterfaceViewTemplate{
    protected _interfaceApi: InterfaceApi;



    protected abstract _viewName: string;

    #_interfacePlatformDocument: InterfacePlatformDocument;
    #_resourceUrl: string = "";

    protected _targetContainer: HTMLElement;
    protected _targetContainers: HTMLElement[];



    set interfaceApi(value: InterfaceApi) {
        this._interfaceApi = value;
    }

    /**
     * 任意のビュー名を戻す
     * (次の処理をビュー名に応じて振り分けるために使用)
      */
    public get viewName(): string {
        return this._viewName;
    }


    /**
     * このコンストラクタのパラメータは、主に既存のビューに別のビューを埋め込む際に使用する。
     * 純粋なwebページのように、ビューを埋め込まない場合は、以下の値を渡す。
     * super(
     *   new NullPlatformDocument(),
     *   "html/null_view.html",
     *   null,
     *   new NullTargetContainerFormatter()
     * );
     * @param interfacePlatformDocument プラットフォームに応じた挿入するドキュメントをHTMLのパスから取得・生成するためのストラテジー
     * ex. Chrome拡張機能の場合はサイトにドキュメントを挿入するのでChromeExtensionPlatformDocument
     * ex. Webの場合はサイトにドキュメントを挿入しないのでNullPlatformDocument
     * など
     * @param htmlPath ビューのHTMLのパス(プロジェクト内のhtml/から始まる相対パス)
     * @param targetContainerBeforeFormat ビューの挿入先であるHTML要素。イテラブル(NodeListやHTMLCollectionなど)であってもなくても良い
     * 第4引数で指定したフォーマッターによってバリデーションが行われHTMLElementに型変換される
     * @param targetContainerFormatter targetContainerの形式を扱いやすいようにするフォーマッター
     * this._targetContainer: HTMLElement // イテラブルで渡された場合、最初の要素が振り分けられる
     * this._targetContainers: HTMLElement[] // イテラブルで渡されてない場合、最初の要素のみの配列となる
     * にtargetContainerBeforeFormatで指定したHTML要素が振り分けられる
     */
    protected constructor(
        interfacePlatformDocument: InterfacePlatformDocument = new NullPlatformDocument(),
        htmlPath: string = "",
        targetContainerBeforeFormat: (HTMLElement | HTMLCollection | NodeList | Element | null) = null,
        targetContainerFormatter: TargetContainerFormatterInterface = new NullTargetContainerFormatter()
    ) {
        this.#_interfacePlatformDocument = interfacePlatformDocument;

        // プロジェクト内のhtml/から始まる相対パスを、プラットフォームに応じてを読み込むためのパス変更する
        // (ex. Chrome拡張の場合はchrome.runtime.getURL()を使うなど)
        this.#_resourceUrl = this.#_interfacePlatformDocument.convertHtmlPathToResourceUrl(htmlPath);

        // targetContainerの形式を扱いやすいようにするフォーマッター
        // typescriptのstrictPropertyInitializationエラーを避けるため、参照ではなく戻り値でフィールドを定義している
        const { targetContainer, targetContainers } = targetContainerFormatter.format(targetContainerBeforeFormat);
        this._targetContainer = targetContainer;
        this._targetContainers = targetContainers;

        this._interfaceApi = new NullApi();
    }



    /**
     * プラットフォームに応じた挿入するドキュメントを取得して、そのドキュメントまたは元々あるdocumentにviewを描画する
     */
    public async append(): Promise<boolean> {
        try {
            // プラットフォームに応じた挿入するドキュメントを取得する
            const DocumentForInsert = await this.#_interfacePlatformDocument.append(this.#_resourceUrl);
            await this.render(DocumentForInsert);
            return true;
        } catch(e) {
            const error = e as Error;
            const errors = {"isError": true, "errorCode": error.name, "errorMessage": error.message};
            console.error(errors);
            console.error(error.stack);
            return false;
        }
    }

    /**
     * プラットフォームに応じた挿入するドキュメントまたは元々あるdocumentにviewを描画する
     * テンプレートメソッド
     * @param DocumentForInsert viewのHTMLのDOM
     */
    protected abstract render(DocumentForInsert: Document): void



    /**
     * プラットフォームに応じた挿入するドキュメントを非表示にする
     * (要素ノード自体を取り除く)
     */
    public remove(): void {
        this.clear();
    }

    /**
     * viewを取り除く
     * フック
     * @protected
     */
    protected clear(): void { }
}



















